var _defs, _style, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 20,
    height: 20,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAAXNSR0IB2cksfwAAAWJQTFRFDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMaDpMattKMAwAAAHZ0Uk5TAAhWo9Xt7tmrYBBQ0f/6+d5hhdR2Nx8dMmzJmwX9ewkCZvOfTQEMDUDwawraC9LlHFoa0wTj+Lt3rG0bxy0Z9+/2Fgfg9fH0FSAGJ+b7FLlcQWnA6P6lihPqV+IePSjsMyYpId1PPNvCrkcDEj6eeNeLIoLOjmNRxPsAAAEbSURBVHicVVBnV8JAEFyjJLEMoiDY0IgSxSA2xAKKIIlYsDfsXez9/3sFeM/9cDM3u2/LEPGoUWrrXKqm1zdQNRqbALib2eNpqWitgNfX5g+0d3QCXd1lLdjTK9NGXwj9nAzArTAIm4MGg6EIhomsKHw8NxIbHeM4DtcEKZiM8485lfCLFtOYoVnMCR5OBuJyFaQoivnyEEPiQlqlxUxWcCulJQVZytnkLOcFN11YEWTVY1MuuCbF9YIctBFyaBNb/8VtxGgHu1Lc25fiAQ7pqIhjIZ6kTzmeFRLnxEovLvlGV9fciptbVsi21lG8qxh2/4CSMMd6BPSnbPz55fUtiFK+fMu7Azjah8qc/rSq1n99/0TsjOP9lSf/AcN9J+tq3OYZAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenWarning);
export default __webpack_public_path__ + "static/media/greenWarning.6286ab1d7c25bb8dd8bce50cd7bc01e4.svg";
export { ForwardRef as ReactComponent };